import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles(() => ({
  checkbox: {
    height: 34,
  },
}));
